import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemAms} from '../AM/FormChooseAm.jsx'
import Model from './ModelAmai.mjs'

export const FormItemAiName = props => (
    <FormItemBizProp
        Model={Model}
        prop="aiName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemAiNo = props => (
    <FormItemBizProp
        Model={Model}
        prop="aiNo"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseAmai(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemAms />
            <FormItemAiNo />
            <FormItemAiName />
        </FormChooseDesign>
    )
}
